import { render } from "./CreateClanModal.vue?vue&type=template&id=5baa3a3a&scoped=true"
import script from "./CreateClanModal.vue?vue&type=script&lang=js"
export * from "./CreateClanModal.vue?vue&type=script&lang=js"

import "./CreateClanModal.vue?vue&type=style&index=0&id=5baa3a3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5baa3a3a"]])

export default __exports__